import { render, staticRenderFns } from "./SlipperyRatingTranslation.vue?vue&type=template&id=105a348a"
import script from "./SlipperyRatingTranslation.vue?vue&type=script&lang=js"
export * from "./SlipperyRatingTranslation.vue?vue&type=script&lang=js"
import style0 from "./SlipperyRatingTranslation.vue?vue&type=style&index=0&id=105a348a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports